import * as React from 'react'

function SuccessIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={161.047} height={113.283} viewBox="0 0 161.047 113.283" {...props}>
      <defs>
        <clipPath id="a">
          <path data-name="Rectangle 7180" fill="#fff" stroke="#707070" strokeWidth={1} d="M0 0H108V101H0z" />
        </clipPath>
      </defs>
      <g data-name="Group 52012">
        <g data-name="Group 53196">
          <g
            data-name="Group 51998"
            transform="translate(-948.117 -282.806) translate(108 -23) rotate(165.02 420.668 227.67)"
          >
            <circle data-name="Ellipse 1015" cx={4.5} cy={4.5} r={4.5} transform="translate(0 25)" fill="#fe5f55" />
            <circle data-name="Ellipse 1026" cx={3.5} cy={3.5} r={3.5} transform="translate(33 21)" fill="#d3dade" />
            <circle data-name="Ellipse 1025" cx={2} cy={2} r={2} transform="translate(25)" fill="#fe5f55" />
          </g>
          <g
            data-name="Group 52000"
            transform="translate(-948.117 -282.806) translate(108 -23) rotate(35.02 -24.73 1730.432)"
          >
            <circle data-name="Ellipse 1015" cx={3} cy={3} r={3} transform="translate(0 14.988)" fill="#d3dade" />
            <circle
              data-name="Ellipse 1026"
              cx={2.5}
              cy={2.5}
              r={2.5}
              transform="translate(18.103 21)"
              fill="#fe5f55"
            />
            <circle data-name="Ellipse 1025" cx={1.5} cy={1.5} r={1.5} transform="translate(12.103)" fill="#fe5f55" />
          </g>
          <g
            data-name="Mask Group 70"
            transform="translate(-948.117 -282.806) translate(108 -23) translate(872 307)"
            clipPath="url(#a)"
          >
            <g transform="translate(-104.758 12.771)">
              <path
                data-name="Path 167"
                d="M102.861 105.347s-2.479 3.637-4.794 4.63a75.838 75.838 0 01-10.949 2.643c-.54 0-.782-1.158-.164-2.643s4.137-5.287 5.122-6.116a48.9 48.9 0 014.63-2.807z"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 168"
                d="M24.047 52.106s2.854 8.485 9.869 11.238 10.534 3.8 10.534 3.8 7.766 23.321 19.747 34.051c0 0-.18 27.372 10.691 42.231 0 0-8.462 20.435-1.509 36.272 0 0-16.924-1.15-19.551 4.38 0 0-11.16-9.2-16.877-13.952S23.726 148.62 21.31 143.435 8.546 106.756 8.015 98.685s1.963-21.35 3-24.244 6.8-16.689 13.032-22.335z"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 169"
                d="M24.047 52.106s-6.256 5.944-11.9 23.532c0 0-.149 38.719 13.389 65.9 0 0 11.731 27.1 28.256 42.52a153.33 153.33 0 01-19.207-9c-8.368-4.888-13.225-15.524-14.3-17.987s-5.388-11.293-8.29-12.927-6.256-5.381-6.374-9.557-.149-14.9-3.128-21.006-3.332-10.589-.868-18.175 7.821-20.161 7.821-20.161 7.773-17.524 14.601-23.139z"
                fill="#595959"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 170"
                d="M46.976 64.274s-13.8 13.928-18.277 19.942-10.166 23.915-10.753 30.438"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Line 74"
                transform="translate(20.511 48.352)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
                d="M5.811 0L0 8.939"
              />
              <path
                data-name="Path 171"
                d="M67.833 99.874s-21.663 10.237-30.25 15.164-10.487 7.226-10.487 7.226"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 172"
                d="M78.418 144.481s-14.859-1.04-26.136-1.6-25.862-6.952-29.28-10.1"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 173"
                d="M75.756 179.799s-18.2-5.38-27.99-12.122-14.577-12.348-14.577-12.348"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 174"
                d="M39.891 140.477l-12.982-14.358 9.948 33.268"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Line 75"
                transform="translate(22.091 97.285)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
                d="M3.206 25.182L0 0"
              />
              <path
                data-name="Path 175"
                d="M14.943 103.182l10.894 20.505-6.6-5.1"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Line 76"
                transform="translate(21.708 123.687)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
                d="M4.129 0L0 5.154"
              />
              <path
                data-name="Line 77"
                transform="translate(27.894 109.211)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
                d="M75.624 0L0 14.28"
              />
              <path
                data-name="Path 176"
                d="M107.914 99.318l3.629-.391a4.325 4.325 0 014.786 3.981h0a4.333 4.333 0 01-3.511 4.567l-9.3 1.767"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 177"
                d="M154.039 3.211s-5.514 4-7.492 7.819-2.205 9.145-11.9 9.531-22.922-.764-25.565 7.44 9.7 9.72 5.513 14.881-11.9 9.909-7.492 16.2 16.423 10.579 21.373 7.623 21.6-14.678 27.99-21.726.219-18.3-1.1-25.548-.219-12.771 3.527-15.246-2.21-1.542-4.854-.974z"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 178"
                d="M131.618 55.766s-5.623 5.474-8.431 6.608a6.4 6.4 0 00-4.137 6.256c0 2.815.172 8.6-.985 10.088s-5.623 7.273-7.273 7.6-4.958.829-6.116 2.479a21.9 21.9 0 00-2.346 4.294c-.665 1.494-8.1 8.1-7.6 8.767l.493.657s4.129 3.308 6.608 3.637a10.5 10.5 0 006.116-1.322 76.031 76.031 0 019.1-4.63c2.479-.829 6.773-2.643 7.273-3.8s4.293-5.122 4.293-5.122 4.3-10.91 4.794-17.987-1.789-17.525-1.789-17.525z"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 179"
                d="M120.372 69.983s.829-5.474 1.157-2.479 2.479 12.4 2.815 16.2a18.77 18.77 0 001.979 6.773s-6.116-6.444-6.608-10.745"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 180"
                d="M109.368 89.417c-1.713-.422-2.291-.461-2.878-.266"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 181"
                d="M128.67 91.303a32.43 32.43 0 01-13.553-.329l-2.667-.735"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 182"
                d="M189.136 46.678s10.573 3.965 11.074 5.122 1.971 12.231 1.971 12.231l.665 12.231s10.91 62.971 10.91 65.778-3.128 4.3-8.431 4.3-16.368-5.787-26.449-6.256-17.682.328-28.756 2.972-22.68 6.256-29.921 6.256a28.739 28.739 0 01-11.863-2.289s24.126-31.736 26.113-49.418 1.986-30.414 1.65-31.736a64.916 64.916 0 01-.493-6.773s-4.3-.172 7.93-5.474 35.021-6.78 45.6-6.944z"
                fill="#d3dade"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 183"
                d="M197.232 63.344l-.164-8.43-6.616-7.743c2.839 1.1 9.385 3.723 9.776 4.63.493 1.157 1.979 12.231 1.979 12.231l.665 12.231s10.91 62.971 10.91 65.778a3.191 3.191 0 01-1.025 2.346 4.954 4.954 0 00-.3-2.7c-.5-1.814-9.924-9.752-9.924-9.752z"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 184"
                d="M187.318 100.281l4.411 16.087s7.93 14.077 10.573 25.346 4.411 15.2 4.849 22.922 6.17 47.6 6.17 47.6 8.829 3.05 13.678 3.05 9.033-1.767 6.608 2.424-11.324 6.483-13.749 6.483a17.769 17.769 0 00-5.216 1.04s1.322 1.322-.219 1.767-6.608 1.322-7.273 1.095-1.76-4.841-2.424-8.6-.657-6.827-1.1-7.93-7.273-23.8-8.6-27.544a68.291 68.291 0 01-2.862-16.095c0-3.746-.665-10.167-.665-10.167s-14.765-18.691-17.627-22.468-5.068-7.273-6.389-7.938-3.965 1.322-3.965 1.322-11.9 21.6-15.641 26.668-10.558 15.8-10.558 15.8-7.93 11.238-11.238 14.765-9.478 9.7-10.581 10.354-11.677 15.867-12.782 17.416-4.411 11.238-8.814 12.122-5.068-6.17-4.192-8.6 4.849-8.376 7.719-11.019 13-21.381 15.868-25.808 7.907-15.8 9.447-18.441 6.186-13.49 6.186-13.49l16.086-41.17 2.2-7.273z"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 185"
                d="M170.712 102.227s1.236 4.825.829 5.795a7.6 7.6 0 01-1.384 1.932l-1.791-1.658"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 186"
                d="M184.195 106.091a21.9 21.9 0 01-6.483 5.1"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 187"
                d="M179.085 112.754a9.656 9.656 0 01-2.033.782"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 188"
                d="M184.5 109.673s-2.19 1.4-4.309 2.526"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 189"
                d="M156.229 108.586a11.6 11.6 0 00-2.346-.978"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 190"
                d="M164.37 113.122s-3.48-2.065-6.483-3.676"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 191"
                d="M154.477 105.575s5.787 2.346 6.624 3.308"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 192"
                d="M214.421 227.004c-1.564.438-6.608 1.322-7.273 1.095s-1.76-4.841-2.424-8.6-.657-6.827-1.1-7.93c-.321-.782-4-12.943-6.5-21a39.735 39.735 0 0012.88-2.244c1.619 12.036 3.324 23.915 3.324 23.915s8.829 3.05 13.678 3.05 9.033-1.767 6.608 2.424-11.324 6.483-13.749 6.483a17.764 17.764 0 00-5.216 1.04s1.313 1.322-.228 1.767z"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 193"
                d="M210.886 185.868l.594 4.035a1.04 1.04 0 01-.329.915c-.868.782-3.23 2.51-7.75 3.347-3.644.673-5.388.6-6.194.446a1.017 1.017 0 01-.782-.72l-1.478-5.107a1.033 1.033 0 01.915-1.322c2.862-.219 9.854-.884 13.6-2.4a1.04 1.04 0 011.423.805z"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 194"
                d="M93.899 225.831c-4.411.876-5.068-6.17-4.192-8.6s4.849-8.376 7.719-11.019c1.814-1.681 6.561-9.838 10.519-16.7a19.613 19.613 0 009.463 5.138 16.622 16.622 0 01-1.916 1.642c-1.095.665-11.676 15.868-12.779 17.416s-4.411 11.24-8.814 12.123z"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 195"
                d="M110.526 184.452s-.782.563 1.455 3.253a9.851 9.851 0 006.507 3.48 35.981 35.981 0 003.707-1.236s.782 0 .109 1.118-3.511 5.068-5.044 5.951c-2.917 1.681-5.162 1.118-8.6-.227-3.019-1.165-3.48-3.48-3.48-4.262s2.471-5.162 3.363-7.038 1.756-1.485 1.983-1.039z"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 196"
                d="M187.096 96.972l.438 4.622h-25.338c-5.514 0-16.095.219-16.095.219l1.1-3.965s19.176-4.4 26.23-4.4a33.109 33.109 0 0113.665 3.524z"
                fill="#9c9c9c"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 197"
                d="M173.653 41.001a18.768 18.768 0 014.63-.438c3.081 0 10.573 1.322 11.676 5.725s6.389 14.077 6.389 14.077a38.821 38.821 0 01-4.4 11.019c-3.128 4.849-4.192 6.389-4.192 6.389s3.973 15.422 2.205 18.073-3.3 3.3-4.63 3.3-11.895-1.1-20.052 0-17.205 1.322-18.949-.219-3.128-6.389-2.651-8.149 3.089-5.732 2.87-9.7-2.87-8.352-2.87-8.352l-3.081 1.979s-3.089-13-3.965-19.387 1.322-6.4 2.643-10.167 10.8-4.184 12.341-4.184 8.157-.665 8.157-.665z"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 198"
                d="M185.407 51.254c-.43-1.564-.735-2.542-.735-2.542"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 199"
                d="M187.754 77.804a44.5 44.5 0 01.227-10.8c.54-2.854-.845-9.142-1.986-13.545"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 200"
                d="M141.964 65.542c-.1-.68-.2-1.369-.258-2.065"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 201"
                d="M143.677 72.729a49.846 49.846 0 01-1.322-5.068"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 202"
                d="M180.34 96.417a129.476 129.476 0 00-13.029 2.51"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 203"
                d="M172.966 6.253s5.662 6.663 5.662 7.993-.336 3 .5 4 4.5 1.83 4.5 3-2.166 3-2.166 3 .837 8.5-.5 9.5-8.165.164-8.165.164a24.74 24.74 0 00.5 5.334 4.2 4.2 0 002.166 1.994s-1.33 5.169-6.663 5.169-10.331-3.832-10.331-3.832 2.839-6.335 2.667-11.832-3.66-13.991-1.666-18.988 8.826-8.309 13.496-5.502z"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 204"
                d="M272.05 190.978c.211.712.665 1.2 1.017 1.095s.469-.782.258-1.47-.657-1.2-1.017-1.087-.469.758-.258 1.462z"
                transform="translate(-96.395 -172.689)"
                fill="#263238"
              />
              <path
                data-name="Path 205"
                d="M176.797 15.275a1.564 1.564 0 00-2.5.336"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 206"
                d="M179.792 25.806s-1.666 1-4-.665"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 207"
                d="M165.95.076c4.4-.282 8.947.149 9.682 2.534.665 2.166-4.6 11.919-7.265 16.744s1.932 20.24-5.9 26.238-14.859-1-14.859-1 7.821 2 8.657-6.827-6.663-12.513-7.82-21.991c-.782-6.569 3.355-11.9 9.259-14.28A34.176 34.176 0 01165.95.076z"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 208"
                d="M204.943 52.568s-2.088-1.979-2.753-1.979-5.177 2.862-5.287 3.3a11.685 11.685 0 00.329 2.424 2.135 2.135 0 00-.548 1.658v1.869l.219 1.658a7.438 7.438 0 00.329 1.869c.219.328 4.074.665 4.958.665h1.564z"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Line 78"
                transform="translate(197.232 53.341)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
                d="M0 2.972L6.061 0"
              />
              <path
                data-name="Line 79"
                transform="translate(196.685 57.306)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
                d="M6.718 0L0 2.534"
              />
              <path
                data-name="Line 80"
                transform="translate(197.122 60.833)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
                d="M6.17 0L0 1.65"
              />
              <path
                data-name="Path 209"
                d="M204.943 52.567l3.637 3.089a2.706 2.706 0 011.1 1.869c.109 1.212 4.63 6.17 3.527 8.157s-3.527 7.164-5.725 8.923a7.539 7.539 0 01-4.63 1.658l-.67-12.231h1.564z"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 210"
                d="M208.032 56.094s-.884 8.485-2.722 9.6-2.424-.219-2.424-.219"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 211"
                d="M211.564 66.23a8.384 8.384 0 01-8.6 1.564"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 212"
                d="M114.593 153.116l7.109-14.374s-4.958 2.643-7.109 3.637-2.815 2.143-2.98 3.8 2.98 6.937 2.98 6.937z"
                fill="#9c9c9c"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 213"
                d="M139.548 98.576s.328 9.916-.993 15.367-4.293 22.484-5.951 23.305-14.859 5.294-18.175 6.616-3.472 1.814-1.822 4.458 3.308 4.3 1.986 4.794-13.717-.328-15.375-.821-2.643-.829-2.643-.829 5.951-12.724 13.881-25.949 13.389-24.134 13.389-24.134 1.322-12.231 2.479-14.382a32.992 32.992 0 002.815-11.238c0-3.144.985-11.4.985-11.4s2.479 11.4 5.474 17.846 4.616 14.545 3.95 16.367z"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 214"
                d="M131.868 93.194c.368-3.754.516-6.773.571-8.172"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 215"
                d="M111.777 144.858s9.924-18.683 14.71-28.1c2.714-5.334 4.215-13.475 5.029-20.286"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 216"
                d="M89.645 110.525s.54 2.291-.454 2.784-2.448.5-2.612 0 .743-2.831 1.728-3.167a1.017 1.017 0 011.338.383z"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 217"
                d="M91.06 109.149l-.422 2.862a1.017 1.017 0 001.314 1.118l5.889-1.83s.493-2.346-.172-2.346-6.116.031-6.609.196z"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Line 81"
                transform="translate(96.034 109.258)"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
                d="M0.36 0L0 2.432"
              />
              <path
                data-name="Line 82"
                transform="translate(93.063 109.172)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
                d="M0.54 0L0 3.332"
              />
              <path
                data-name="Path 218"
                d="M94.76 101.883s-2.98.985-5.13 1.979-3.464 3.472-4.958 5.122-3.637 3.472-1.979 3.472 3.637-.657 4.294-1.65a7.259 7.259 0 012.346-1.822s4.129-.328 5.122-.328 3.128-2.479 3.128-2.479"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
              <path
                data-name="Path 219"
                d="M136.905 48.986s.657 11.41 2.346 17.987.164 41 .164 41 .665-11.9-3.472-21.162-7.109-23.634-7.109-25.808 2.346-5.779 3.308-7.109 3.277-5.237 4.763-4.908z"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeMiterlimit={10}
                strokeWidth={1}
              />
            </g>
          </g>
          <g data-name="Group 52529">
            <g data-name="Group 52158">
              <circle
                data-name="Ellipse 1015"
                cx={14.089}
                cy={14.089}
                r={14.089}
                fill="#fe5f55"
                transform="translate(-948.117 -282.806) translate(108 -23) translate(1019.871 385.684) translate(-150.274 5.227)"
              />
            </g>
            <path
              data-name="Subtraction 97"
              d="M4.862 8.871L14.046 0H11.3L4.862 6.174 2.8 4.159H0z"
              transform="translate(-948.117 -282.806) translate(108 -23) translate(1019.871 385.684) translate(-142.604 14.859)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default SuccessIcon
